app.directive('fileModel', ['$parse', function($parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;
            element.bind('change', function() {
                scope.$eval(attrs.customOnChange);
                scope.$apply(function() {
                    //console.log('scope before', scope);
                    modelSetter(scope, element[0].files[0]);
                    //console.log('scope after', scope);
                })
            });
        }
    };
}]);